import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import { 
    REFERENCES_ALL_URL,
 } from '../../../vars'

 /**
  * @namespace Statistic
  * @description Статистика (Page: /dashboard)
  */
export default {
    state: {
        references: {
            'scientific_area' : [],
            'organization': [],
            'orgposition': [],
            'method': [],
        }
        
    },
    mutations: {
        UPDATE_REFERENCES(state, data) {
            state.references[data.bd_name] = data.data;
        },

    },
    actions: {
        async GET_REFERENCE(ctx, data) {
            try {
                const res = await axios.get(REFERENCES_ALL_URL + `?bd_name=${data.bd_name}`, {
                    headers: {
                    Authorization: `Token ${localStorage.token}`,
                    },
                });
                await ctx.commit('UPDATE_REFERENCES', {bd_name: data.bd_name, data: res.data});    
                return res;
            } catch (e) {
                console.log('GET_REFERENCE error', e)
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                throw e;
            }
        },

        async UPDATE_REFERENCE(ctx, data) {
            try {
                var res = null
                if(data.data.id !== undefined && data.data.id > 0){
                    res = await axios.patch(REFERENCES_ALL_URL, data, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                    });
                }
                else{
                    res = await axios.post(REFERENCES_ALL_URL, data, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                    });
                }
                return res;
            } catch (e) {
                console.log('UPDATE_REFERENCE error', e)
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                throw e;
            }
        },
    },
    getters: {
        GETTERS_REFERENCES: (state) => (bd_name) => {
            return state.references[bd_name]
        },
        
    }
}